module.exports = __webpack_public_path__ + "static/media/foret.cb01699b.jpg";